import styled from 'styled-components';
import {device} from 'styled/device';

export const Wrapper = styled.div`
  width: 100%;

  & .custom-icon {
    margin: 0 auto 40px;
  }
`;

export const Title = styled.div`
  font-size: ${props => props.theme.fonts.sizes.$large};
  color: ${props => props.theme.colors.branding.fontPrimary};
  font-weight: 600;
  text-align: center;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0.36px;
  margin-bottom: 40px;

  @media (min-width: ${device.tabletG}) {
    margin-top: 24px;
    font-size: 28px;
  }
`;

export const SecondaryText = styled.div`
  color: ${props => props.theme.colors.branding.fontPrimary};
  text-align: center;
  font-size: ${props => props.theme.fonts.sizes.$small};
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 24px;

  &.secondary-paragraph {
    margin-bottom: 24px;
  }
  @media (min-width: ${device.tabletG}) {
    font-size: ${props => props.theme.fonts.sizes.$medium};
  }
`;

export const List = styled.div`
  max-width: 501px;
  margin: 0 auto;
`;
export const ListItem = styled.div`
  padding: 12px 0;
  color: ${props => props.theme.colors.branding.fontPrimary};
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: ${props => props.theme.fonts.sizes.$small};
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }

  @media (min-width: ${device.tabletG}) {
    border-bottom: none;
  }
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.branding.primary};
`;
